export enum JobRoutingEnum {
  Root = '',
  JobApply = 'apply',
}
